"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var fireBingPixel = function fireBingPixel() {
  if (!window.FireSPA) {
    console.log('no bing tag!');
    return;
  }

  window.FireSPA('/email_optin');
  console.log('Fired bing pixel');
};

var _default = fireBingPixel;
exports.default = _default;

//# sourceMappingURL=bingPixel.js.map